import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/static-website/src/components/layout/PageLayout/PageLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/static-website/src/components/sections/StatusSection/StatusSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NAVIGATION_CONFIG"] */ "/var/www/static-website/src/static/content/pl/navigation.tsx");
